<section
	ucUniImpressionGA
	[uniId]="uni().id"
	[uniName]="uni().name"
	[product]="product()"
	[ugSearchOrderPosition]="ugso()"
	[cleSearchOrderPosition]="cleso()"
	class="bg-white divider"
>
	<div class="flex flex-col">
		<div class="relative overflow-hidden">
			<!-- Desktop: cover photo + bookmark -->
			<div class="hidden h-full md:flex">
				<div class="relative w-1/2 md:">
					<div class="absolute z-10 top-4 right-4 md:z-[45] h-10">
						<uc-bookmark
							[bookmarkHeartIcon]="true"
							[saved]="uni().saved ? 1 : 0"
							[id]="uni().id"
							[delta]="1"
							[componentName]="componentName()"
							[product]="product()"
							[ugSearchOrderPosition]="ugso()"
							[cleSearchOrderPosition]="cleso()"
							[uniName]="uni().name"
							data-cy="recommended-uni-single-bookmark"
						/>
					</div>
				</div>

				<a
					[routerLink]="'/universities/' + uni().slug"
					ucUniProfileGA
					[eventTypes]="['click']"
					[uniId]="uni().id"
					[uniName]="uni().name"
					[product]="product()"
					[ugSearchOrderPosition]="ugso()"
					[cleSearchOrderPosition]="cleso()"
					class="hidden md:flex"
					data-cy="recommended-uni-single-cover-photo"
					aria-label="View recommended university"
				>
					<uc-engage-card-cta-img
						[backgroundImage]="uni().profile?.cover_image ?? ''"
						[border]="false"
					/>
					<span class="sr-only">View recommended university</span>
				</a>
			</div>

			<!-- Internal Link -->
			<div class="relative pt-6 mx-auto md:py-12 max-w-7xl">
				<div class="lg:px-5 md:ml-auto md:w-1/2 md:pl-8 lg:pl-16">
					<!-- icon & uppercase icon text -->
					<div class="flex items-center gap-3">
						<img
							[ngSrc]="'/assets/img/fire.svg' | cdn"
							width="20"
							height="20"
							alt=""
						/>
						<p class="font-semibold text-gray-500 uppercase">
							Recommended University
						</p>
					</div>

					<!-- title -->
					<p class="flex flex-wrap-reverse mt-2 tracking-tight">
						<a
							[routerLink]="'/universities/' + uni().slug"
							ucUniProfileGA
							[eventTypes]="['click']"
							[uniId]="uni().id"
							[uniName]="uni().name"
							[product]="product()"
							[ugSearchOrderPosition]="ugso()"
							[cleSearchOrderPosition]="cleso()"
							data-cy="recommended-uni-single-title"
							class="text-2xl font-bold md:text-3xl"
						>
							{{ uni().name }}
						</a>
					</p>

					<!-- description -->
					<p class="mt-4 text-base text-gray-500">
						{{ description() }}
						<ng-content select="[leave-review]"></ng-content>
					</p>

					<!-- CTA button -->
					<div class="mt-8">
						@if (uni().stats.recommended_percentage === 0) {
							<uc-write-review-btn
								leave-review
								[universityId]="uni().id"
								[universityName]="uni().name"
								[universityUrl]="uni().slug"
								buttonText="Leave a review"
								customStyles="text-base"
							/>
						}

						<div class="flex gap-3">
							@if (!isClearing() && showRequestBtn()) {
								<uc-request-btn
									class="w-full sm:w-auto"
									[params]="uni().id"
									[componentName]="componentName()"
									[product]="product()"
									[ugSearchOrderPosition]="uni().order"
								/>
							}
							<uc-recommended-visit-website-btn
								class="w-full sm:w-auto"
								[uniId]="uni().id"
								[uniName]="uni().name"
								[externalUrl]="uni().profile?.external_url ?? ''"
								[searchOrderPosition]="uni().order"
								[componentName]="componentName()"
								[product]="product()"
								customStyles="!block !w-full sm:!w-auto"
								[privacyPolicyUrl]="uni().privacy_policy_url"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
